/**
 * Detect soft-deleted doctor accounts across hire / messages / pre-credential.
 * Prefer explicit backend flags; fall back to name/email conventions set on account delete.
 */
export function isDeletedDoctor(row: {
  doctorDeleted?: boolean | null;
  deleted?: boolean | null;
  doctor?: {
    deleted?: boolean | null;
    deletedTime?: number | null;
    doctorName?: string | null;
    email?: string | null;
  } | null;
  doctorProfile?: {
    deletedTime?: number | null;
    fullName?: string | null;
    email?: string | null;
  } | null;
  applicationDetails?: {
    doctor?: {
      deletedTime?: number | null;
      fullName?: string | null;
      firstName?: string | null;
      surname?: string | null;
      email?: string | null;
      deleted?: boolean | null;
    } | null;
  } | null;
  doctorName?: string | null;
  doctorEmail?: string | null;
  fullName?: string | null;
} | null | undefined): boolean {
  if (!row) return false;
  if (row.doctorDeleted === true || row.deleted === true || row.doctor?.deleted === true) {
    return true;
  }
  if (row.applicationDetails?.doctor?.deleted === true) {
    return true;
  }

  const deletedTime = Number(
    row.doctor?.deletedTime ??
      row.doctorProfile?.deletedTime ??
      row.applicationDetails?.doctor?.deletedTime ??
      0,
  );
  if (Number.isFinite(deletedTime) && deletedTime > 0) {
    return true;
  }

  const name = String(
    row.doctor?.doctorName ||
      row.doctorProfile?.fullName ||
      row.fullName ||
      row.doctorName ||
      [
        row.applicationDetails?.doctor?.firstName,
        row.applicationDetails?.doctor?.surname,
      ]
        .filter(Boolean)
        .join(" ") ||
      row.applicationDetails?.doctor?.fullName ||
      "",
  )
    .trim()
    .toLowerCase();
  if (name === "deleted user") {
    return true;
  }

  const email = String(
    row.doctorEmail ||
      row.doctor?.email ||
      row.doctorProfile?.email ||
      row.applicationDetails?.doctor?.email ||
      "",
  )
    .trim()
    .toLowerCase();
  return email.startsWith("del-");
}
